import React from 'react';
import { useFormikContext } from 'formik';
import { Loader } from 'ui';

export const FormikLoader: React.FC<React.PropsWithChildren> = ({
  children,
  ...props
}) => {
  const { isSubmitting } = useFormikContext();

  return (
    <Loader loading={isSubmitting} {...props}>
      {children}
    </Loader>
  );
};
